import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class UserActionsContactAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "sendingContactForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj) => this.privateRequest('post', 'user/contact', dataObj)
        });
        // RS-8: outcome of a submit attempt (persisted | processing | failed | unknown). Used to resolve a
        // lost or slow answer instead of sending the form again.
        Object.defineProperty(this, "getAttemptStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (attemptId) => this.request('get', `user/contact/attempt/${encodeURIComponent(attemptId)}`)
        });
        // ADV-261: best-effort beacon for the lead micro-funnel's client-only stages
        // (lead_form_start, lead_form_submit_attempt) — must never block or break the actual form.
        Object.defineProperty(this, "trackLeadFunnelEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'user/contact/track', data).catch(() => undefined)
        });
        Object.defineProperty(this, "requestOffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'user/expanded-contact', data)
        });
        Object.defineProperty(this, "submitOfferRequestForCustomers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'sale/expanded-contact', data)
        });
        Object.defineProperty(this, "requestOfferByID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, userID) => this.request('post', `user/expanded-contact/${userID}`, data)
        });
        Object.defineProperty(this, "checkCaptcha", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj) => this.request('post', 'user/contact/captcha', dataObj)
        });
        Object.defineProperty(this, "submitInvalidContactFormInformation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                return this.request('post', 'user/contact/invalid', data);
            }
        });
        Object.defineProperty(this, "addCheckoutStepData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                return this.privateRequest('post', `user/checkout/invalid`, data);
            }
        });
        Object.defineProperty(this, "updateCheckoutStepData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                return this.privateRequest('put', `checkouts`, data);
            }
        });
        Object.defineProperty(this, "getCheckoutCarList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.privateRequest('get', `checkouts`)
                    .then(({ results = [] }) => {
                    return results ? results : [];
                });
            }
        });
        Object.defineProperty(this, "getCheckoutCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => {
                return this.privateRequest('get', `checkouts/car/${carId}`)
                    .then((response) => {
                    return response ? response : {};
                });
            }
        });
        /** The customer's Widerruf of an order: its Odoo request gets the tag "Widerruf" and a note. */
        Object.defineProperty(this, "sendWithdrawal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => this.privateRequest('post', 'contracts/withdrawal', data)
        });
        this.setConfig(config);
    }
}
export default new UserActionsContactAPI({
    baseURL: config.userActionsAPI.contactUrl
});
